module.exports = __webpack_public_path__ + "static/media/investors-web.81780b39.png";